import $ from 'jquery';
import bindEvent from '../../scripts/util/bindEvent';
import addClass from '../../scripts/util/DOM/addClass';
import TweenMax from 'TweenMax';
import Power2 from 'animation.gsap';

const selectors = {
	card: '.js-info-card',
	button: '.js-info-card-button',
	text: '.js-block-text',
	sliderMobile: '#slider-mobile-card'
};

const classes = {
	active: 'info-card_active'
};

const showText = (card, text) => {
	addClass(classes.active)(card);
	TweenMax.set(text, {height: 'auto'});
	TweenMax.from(text, 0.3, {height: 0, ease: Power2.easeInOut});
};

const changeButtonText = button => {
	const text = button.innerHTML;

	if (text === 'подробнее') {
		button.innerHTML = 'свернуть';
	} else {
		button.innerHTML = 'подробнее';
	}
};

const hideText = (card, text) => {
	card.classList.remove(classes.active);
	TweenMax.to(text, 0.3, {height: 0, ease: Power2.easeInOut});
};

const toogleText = e => {
	const button = e.target;
	const card = button.closest(selectors.card);
	const text = card.querySelector(selectors.text);

	if (card.classList.contains(classes.active)) {
		hideText(card, text);
	} else {
		showText(card, text);
	}

	changeButtonText(button);
};

const render = () => {
	if ($(selectors.sliderMobile) !== null) {
		const slideSlick = $(selectors.sliderMobile);
		slideSlick.slick({
			prevArrow: '',
			nextArrow: '',
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: true,
			focusOnSelect: false
			// initialSlide: 0
		});
	}

	bindEvent(selectors.button, 'click', toogleText);
};

export default render;
